import { Header, Icon, Message, Segment } from "@/components/bp/bp-ui";
import { Frown } from 'lucide-react';

const BPUnexpectedError: React.FC = () => {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon><Frown size={50} /></Icon>
                Unexpected Error
            </Header>
            <div style={{ textAlign: "center" }}>
                <p>Sorry, something went wrong.</p>
            </div>
        </Segment>
    );
};

export default BPUnexpectedError;
